const INFO = {
	main: {
		title: "Portfolio Roxane VALLEE",
		name: "Roxane VALLEE",
		email: "roxanevallee@outlook.com",
		logo: "../avatar.png",
	},

	socials: {
		github: "https://github.com/roxyvallee",
		linkedin: "https://www.linkedin.com/in/roxane-vallee/",
	},

	homepage: {
		title: "Game Programmer",
		description:
		"Welcome to my portfolio, where you can explore both my professional and personal projects, as well as learn about my academic background, experiences, and skills. With 4 years of experience as a video game programmer, I am dedicated to the art of creating captivating interactive worlds. My expertise spans game development using a variety of languages, with particular proficiency in C# and mastery of the Unity engine.",
	},

	about: {
		title: "👋Welcome, I’m Roxane",
		description:
		"As a game programmer with 4 years of experience, I specialize in developing interactive applications. My background includes creating games and immersive experiences using various programming languages, with particular expertise in C# and Unity. I am adaptable and skilled in managing multiple tasks while staying up-to-date with new technologies, especially those in the game industry. I thrive on challenging myself and excel at solving technical and gameplay issues.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},
};

export default INFO;
